<div class="form-header">
  <span *ngIf="edited.id && edited.id > 0">Edit</span>
  <span *ngIf="!edited.id || edited.id === -1">Add</span>
  provider/payor endpoint
</div>

<form [formGroup]="providerEndpointForm" (ngSubmit)="onSubmitForm()" >
  
<div class="dialog-container" >
  <div class="field" required>
    <mat-form-field>
      <mat-label>Registration Id</mat-label>
      <input matInput formControlName="registrationId" maxlength="24" name="registrationId">
    </mat-form-field>
  </div>
  <div class="field" required>
    <mat-form-field>
      <mat-label>Organization Code</mat-label>
      <input matInput formControlName="organizationCode" maxlength="255" name="organizationCode">
    </mat-form-field>
  </div>
  <div class="field" required >
    <mat-form-field >
      <mat-label>Organization Name</mat-label>
      <textarea class="description-field" rows="4" columns="50" maxlength="512" matInput formControlName="organizationName" name="organizationName"></textarea>
    </mat-form-field>
  </div>
  <div class="field" required>
    <mat-form-field>
      <mat-label>Registration Id</mat-label>
      <input matInput formControlName="registrationId" maxlength="24" name="registrationId">
    </mat-form-field>
  </div>
  <div class="field" required >
    <mat-form-field appearance="fill">
      <mat-label>Endpoint Type</mat-label>
      <mat-select    formControlName="endpointType">
        <mat-option [value]="'Payor'">Payor</mat-option>
        <mat-option [value]="'Provider'">Provider</mat-option>
      </mat-select>
    </mat-form-field>
    
  </div>
  <div class="field" required >
    <mat-form-field appearance="fill">
      <mat-label>Client Auth Type</mat-label>
      <mat-select  formControlName="clientAuthType" >
        <mat-option [value]="'CLIENT_SECRET'">Client Secret</mat-option>
        <mat-option [value]="'PKCE'">PKCE</mat-option>
        <mat-option [value]="'JWK'">JWK</mat-option>
        <mat-option [value]="'BASIC_AUTH'">Client Secret with Basic Auth</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="field" required >
    <mat-form-field appearance="fill">
      <mat-label>API Level</mat-label>
      <mat-select  formControlName="apiLevel" >
        <mat-option [value]="'R4'">R4</mat-option>
        <mat-option [value]="'DSTU'">DSTU</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="field" required>
    <mat-form-field>
      <mat-label>Client ID</mat-label>
      <input matInput formControlName="clientId" maxlength="64" name="clientId">
    </mat-form-field>
  </div>
  <div class="field" required>
    <mat-form-field>
      <mat-label>Client Secret</mat-label>
      <input matInput formControlName="clientSecret" maxlength="128" name="clientSecret">
    </mat-form-field>
  </div>  
  <div class="field" required >
    <mat-form-field >
      <mat-label>Redirect URI</mat-label>
      <textarea class="description-field" rows="4" columns="50" maxlength="2083" matInput formControlName="redirectUri" name="redirectUri"></textarea>
    </mat-form-field>
  </div>  
  <div class="field" required >
    <mat-form-field >
      <mat-label>Scope</mat-label>
      <textarea class="description-field" rows="4" columns="50" maxlength="2083" matInput formControlName="scope" name="scope"></textarea>
    </mat-form-field>
  </div> 
  <div class="field" required >
    <mat-form-field >
      <mat-label>Authorization Base URL</mat-label>
      <textarea class="description-field" rows="4" columns="50" maxlength="2083" matInput formControlName="authorizationBaseUrl" name="authorizationBaseUrl"></textarea>
    </mat-form-field>
  </div> 
  <div class="field" required >
    <mat-form-field >
      <mat-label>Token URL</mat-label>
      <textarea class="description-field" rows="4" columns="50" maxlength="2083" matInput formControlName="tokenUrl" name="tokenUrl"></textarea>
    </mat-form-field>
  </div> 
  <div class="field" required >
    <mat-form-field >
      <mat-label>Register URL</mat-label>
      <textarea class="description-field" rows="4" columns="50" maxlength="2083" matInput formControlName="registerUrl" name="registerUrl"></textarea>
    </mat-form-field>
  </div> 
  <div class="field" required >
    <mat-form-field >
      <mat-label>Resource URL</mat-label>
      <textarea class="description-field" rows="4" columns="50" maxlength="2083" matInput formControlName="resourceBaseUrl" name="resourceBaseUrl"></textarea>
    </mat-form-field>
  </div> 
  <div class="field" required >
    <mat-form-field >
      <mat-label>Audience</mat-label>
      <textarea class="description-field" rows="4" columns="50" maxlength="2083" matInput formControlName="audience" name="audience"></textarea>
    </mat-form-field>
  </div> 
  <div class="button-container">
    <button class="dialog-button" [disabled]="isFormInValid()" type="submit" mat-flat-button color="primary" >Save</button>
    <button class="dialog-button" mat-flat-button color="primary" type="reset" (click)="close()">Cancel</button>
  </div>
</div>

</form>
